import { connect } from 'react-redux'

import CustomFieldSearchView from './CustomFieldSearchView.jsx';
import { fetchCustomFields } from 'src/legacy/redux/actions/customFields.jsx';


const mapStateToProps = (state, ownProps) => {
  var searchableCustomfields = [];
searchableCustomfields = state.legacyRootReducer.settings.customFields.items.filter((field)=>
    field.searchable == true
)
  return {

  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchCustomFields: () => {
      return dispatch(fetchCustomFields());
    }
  }
}

const CustomFieldSearchViewContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomFieldSearchView)

export default CustomFieldSearchViewContainer